export default __webpack_public_path__ + "static/media/icon-hamburger.634fd548.svg";